module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_3@2x.a73779e.webp";